import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagMX = function FlagMX() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
    fill: "#F0F0F0",
    d: "M25 50c13.807 0 25-11.193 25-25S38.806 0 25 0 0 11.193 0 25s11.193 25 25 25Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#D80027",
    d: "M50 24.999c0-9.912-5.768-18.476-14.13-22.52v45.039C44.232 43.474 50 34.91 50 24.998Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#6DA544",
    d: "M0 24.999c0 9.911 5.768 18.475 14.13 22.519V2.48C5.768 6.523 0 15.087 0 24.999ZM18.479 25a6.522 6.522 0 0 0 13.043 0v-2.175H18.479V25Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#FF9811",
    d: "M33.695 20.652h-6.522a2.174 2.174 0 0 0-4.347 0h-6.522c0 1.201 1.046 2.174 2.246 2.174h-.072c0 1.2.973 2.174 2.174 2.174 0 1.2.973 2.174 2.174 2.174h4.347c1.2 0 2.174-.973 2.174-2.174 1.2 0 2.174-.973 2.174-2.174h-.072c1.2 0 2.246-.973 2.246-2.174Z"
  }));
};
FlagMX.displayName = 'FlagMX';
export default withFlagWrapper(FlagMX);
//# sourceMappingURL=index.js.map